<template>
  <div class="detail-affiliate-relation">
    <div class="margin-top">
      <el-table
        :data="detailAffiliateRelations"
        border
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          prop="openId"
          :label="$t('affiliate.openId')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="relationLevel"
          :label="$t('affiliate.relationLevel')"
          align="center">
          <template slot-scope="scope">
            {{ _level(scope.row.relationLevel) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="expireTime"
          :label="$t('affiliate.expireTime')"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('affiliate.createTime')"
          align="center">
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { listAffiliateRelation } from '@/api/affiliate/affiliateRelationApi'

export default {
  name: 'DetailAffiliateRelation',
  data() {
    return {
      loading: false,
      detailAffiliateRelations: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      auId: ''
    }
  },
  methods: {
    loadData(params) {
      this.auId = params.auId
      this.getList()
    },
    async getList() {
      this.loading = true
      try {
        const res = await listAffiliateRelation({
          auIdContain2Level: this.auId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        })
        this.detailAffiliateRelations = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取绑定用户列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    _level(state) {
      if (state === "1") {
        return this.$t('affiliate.firstLevel')
      }
      if (state === "2") {
        return this.$t('affiliate.secondLevel')
      }
      return ''
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>